<template>
  <div>
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="90px"
             class="demo-ruleForm">
      <el-row style="margin-bottom:10px;">
        <el-col :span="12">
          <el-form-item label="活动标题:"
                        prop="title">
            <el-input v-model="ruleForm.title"
                      placeholder="必填，2-40个字"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主题模板:"
                        prop="theme">
            <el-select style="width:100%;"
                       v-model="ruleForm.theme"
                       placeholder="请选择">
              <el-option v-for="item in themeList"
                         :key="item.value"
                         :label="item.title"
                         :value="item.value"
                         v-html="'<span style=color:#303030;>'+item.title+'</span>'"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="margin-bottom:10px;">
        <el-col :span="12">
          <el-form-item label="开始时间:"
                        prop="startAt">
            <el-date-picker type="datetime"
                            :clearable="false"
                            :picker-options="pickerOptionsStart"
                            placeholder="选择日期"
                            v-model="ruleForm.startAt"
                            style="width: 100%"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="截止时间:"
                        prop="endAt">
            <el-date-picker type="datetime"
                            :clearable="false"
                            :picker-options="pickerOptionsEnd"
                            placeholder="选择日期"
                            v-model="ruleForm.endAt"
                            style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>

      </el-row>

      <!-- <el-row style="margin-bottom:10px;">
        <el-form-item label="投稿必填:" prop="fillListArray">
          <el-checkbox-group v-model="ruleForm.fillListArray">
            <el-checkbox label="姓名" name="fillListArray"></el-checkbox>
            <el-checkbox label="手机" name="fillListArray"></el-checkbox>
            <el-checkbox label="地址" name="fillListArray"></el-checkbox>
            <el-checkbox label="邮箱" name="fillListArray"></el-checkbox>
            <el-checkbox label="微信号" name="fillListArray"></el-checkbox>
            <el-checkbox label="收款信息" name="fillListArray"></el-checkbox>
            <el-checkbox label="备注" name="fillListArray"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-row> -->

      <!-- <el-row style="margin-bottom:10px;">
        
        

      </el-row> -->

      <el-row style="margin-bottom:10px;">
        <el-col :span="12">
          <el-form-item label="主题图:"
                        prop="psw">
            <div style="float:left;position: relative;margin-right:40px;margin-left:20px;">
              <el-upload class="upload-demo"
                         action="#"
                         :show-file-list="false"
                         :auto-upload="false"
                         :on-change="onChange">
                <!-- <el-tooltip class="item" effect="dark" content="图片大小最好为：1920 * 300" placement="top"> -->
                <div v-if="!thumbnailFile && !isFile"
                     :style="{'fontSize' : '12px' , 'color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">+ 上传网站版主题图</div>
                <!-- </el-tooltip> -->
                <div v-if="isFile"
                     :style="{'fontSize' : '12px' , 'color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
                  <i class="el-icon-loading"></i> <span>正在上传!</span>
                </div>

              </el-upload>

              <div class="msg">
                白色主题图建议大小为1920*600像素
              </div>

              <div v-if="thumbnailFile"
                   class="imgbj">
                <el-image class="imgs"
                          :src="thumbnailFile.src"
                          :preview-src-list="[thumbnailFile.src]"></el-image>
                <p @click.stop="deleteThumbnailFile"
                   :style="{'color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   class="delete">删除</p>
                <!-- <div @click.stop="deleteThumbnailFile" class="delete">
                  <img width="15px" src="@/assets/piclist/mydel.png" alt />
                </div> -->
              </div>
            </div>

            <div style="float:left;position: relative;">
              <el-upload class="upload-demoMo"
                         action="#"
                         :show-file-list="false"
                         :auto-upload="false"
                         :on-change="onChangeMo">
                <!-- <el-tooltip class="item" effect="dark" content="图片大小最好为：1920 * 300" placement="top"> -->
                <div v-if="!thumbnailFileMo && !isFileMo"
                     :style="{'fontSize' : '12px' , 'color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                     style="font-size:12px;">+ 上传手机版主题图</div>
                <!-- </el-tooltip> -->
                <div v-if="isFileMo"
                     :style="{'fontSize' : '12px' , 'color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
                  <i class="el-icon-loading"></i> <span>正在上传!</span>
                </div>

              </el-upload>
              <div class="msg">
                图片大小建议为900*675像素
              </div>

              <div v-if="thumbnailFileMo"
                   class="imgbj">
                <el-image class="imgs"
                          :src="thumbnailFileMo.src"
                          :preview-src-list="[thumbnailFileMo.src]"></el-image>
                <p @click.stop="deleteThumbnailFileMo"
                   :style="{'color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   class="delete">删除</p>
                <!-- <div @click.stop="deleteThumbnailFile" class="delete">
                  <img width="15px" src="@/assets/piclist/mydel.png" alt />
                </div> -->
              </div>
            </div>

          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="稿件正文:"
                        prop="requiredContent">
            <el-radio-group v-model="ruleForm.requiredContent"
                            size="mini"
                            :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'">
              <el-radio-button label="1">必填</el-radio-button>
              <el-radio-button label="0">选填</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="ruleForm.activityType == 'picture'"
                :span="6">
          <el-form-item label="图片备注:"
                        prop="requiredDesc">
            <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                            v-model="ruleForm.requiredDesc"
                            size="mini">
              <el-radio-button label="1">必填</el-radio-button>
              <el-radio-button label="0">选填</el-radio-button>
            </el-radio-group>
          </el-form-item>

        </el-col>
        <el-col v-if="ruleForm.activityType == 'video'"
                :span="6">
          <el-form-item label="视频备注:"
                        prop="requiredDesc">
            <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                            v-model="ruleForm.requiredDesc"
                            size="mini">
              <el-radio-button label="1">必填</el-radio-button>
              <el-radio-button label="0">选填</el-radio-button>
            </el-radio-group>
          </el-form-item>

        </el-col>
      </el-row>

      <el-row type="flex"
              align="middle"
              justify="space-between"
              style="margin-bottom:10px;">
        <el-col :span="12">
          <el-form-item label="投稿角色:"
                        prop="postRole">
            <el-select style="width:100%;"
                       v-model="ruleForm.postRole"
                       placeholder="请选择">
              <el-option v-for="item in roleList"
                         :key="item.value"
                         :label="item.title"
                         :value="item.value"
                         v-html="'<span style=color:#303030;>'+item.title+'</span>'"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">

          <el-form-item label="投稿类型:"
                        prop="postRole">
            <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                            v-model="ruleForm.activityType"
                            size="mini">
              <el-radio-button :disabled="draftactivityName=='修改征稿活动'"
                               label="picture">图文</el-radio-button>
              <el-radio-button :disabled="draftactivityName=='修改征稿活动'"
                               label="video">视频</el-radio-button>
              <el-radio-button :disabled="draftactivityName=='修改征稿活动'"
                               label="document">文稿</el-radio-button>
              <!-- <el-radio-button label="text">文字</el-radio-button>
              <el-radio-button label="mix">混合</el-radio-button> -->
            </el-radio-group>
          </el-form-item>

        </el-col>

      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="投稿限制:">
            <el-row>
              <el-col :span="12">
                <span>&nbsp;&nbsp;每个用户可投</span>
                <el-input-number v-model="ruleForm.articleLimit"
                                 step-strictly
                                 controls-position="right"
                                 :min="1"
                                 style="margin-left:5px;"></el-input-number>
                <span>&nbsp;&nbsp;&nbsp;个稿</span>
              </el-col>
              <el-col v-if="ruleForm.activityType == 'picture'"
                      :span="12">
                <span>&nbsp;&nbsp;&nbsp;每篇稿件可上传</span>
                <el-input-number v-model="ruleForm.postLimit"
                                 step-strictly
                                 controls-position="right"
                                 :min="1"
                                 :max="30"
                                 style="margin-left:5px;"></el-input-number>
                <span>&nbsp;&nbsp;&nbsp;张图</span>
              </el-col>
            </el-row>

          </el-form-item>

        </el-col>
      </el-row>

      <el-form-item label="征稿详情:"
                    prop="desc">
        <!-- <quill-editor
            v-model="content"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @change="onEditorChange($event)"
        ></quill-editor>-->

        <div id="websiteEditorElem"
             style="height:300px;background: #ffffff;"></div>
      </el-form-item>
      <!-- <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>-->
    </el-form>

    <div class="bottombtn">
      <div class="btn">
        <el-button @click="closeForm">取消</el-button>
        <el-button @click="submitForm('ruleForm')"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   type="primary">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addQuillTitle } from "@/plugins/quill-title.js";
import { getDate, formatConversion } from "@/plugins/getdate";
// import { mapGetters } from "vuex";
import { listAllowTheme } from "@/api/pictureActivityTheme";
import E from "wangeditor";
import { picPrefix } from "@/constants/piccommon";
import getMD5 from "@/plugins/getMD5";
import SparkMD5 from "spark-md5";
import {
  uploadPic,
  uploadPicChunk,
  uploadPicChunkMerge,
  getFileInfoById,
  getFileInfoByHash
} from "@/api/file";
export default {
  props: {
    ruleForm: Object,
    draftactivityName: String
  },
  // computed: {
  //   ...mapGetters(["createUid"])
  // },
  data () {
    return {
      //判断背景图是不是在上传
      isFile: false,
      isFileMo: false,
      isUpdata: false,
      picPrefix,
      thumbnailFile: null,
      thumbnailFileMo: null,
      themeList: [],
      roleList: [
        {
          title: '系统默认',
          value: 'default'
        },
        {
          title: '注册用户及认证用户',
          value: 'user'
        },
        {
          title: '仅认证用户',
          value: 'auth'
        }
      ],
      phoneEditor: "",
      rules: {
        title: [
          { required: true, message: "请输入活动标题", trigger: "blur" },
          { min: 2, max: 40, message: "长度在 2 到 40 个字符", trigger: "blur" }
        ],

        startAt: [
          { required: true, message: "请选择开始时间", trigger: "blur" }
        ],

        theme: [
          { required: true, message: "请选择主题模板", trigger: "blur" }
        ],
        requiredContent: [
          { required: true, message: "请选择稿件正文为必填或选填", trigger: "blur" }
        ],
        requiredDesc: [
          { required: true, message: "请选择图片备注为必填或选填", trigger: "blur" }
        ],
        postRole: [
          { required: true, message: "请选择投稿角色", trigger: "blur" }
        ],

        endAt: [{ required: true, message: "请选择截止时间", trigger: "blur" }],

        fillListArray: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个投稿必填",
            trigger: "change"
          }
        ],
        desc: [
          {
            min: 0,
            max: 200,
            message: "长度不得超过200个字符",
            trigger: "blur"
          }
        ]
      },
      content: ``,

      pickerOptionsEnd: {
        disabledDate: time => {
          return this.ruleForm.startAt ? time < this.ruleForm.startAt : "";
        }
      },

      pickerOptionsStart: {
        disabledDate: time => {
          return this.ruleForm.endAt ? time > this.ruleForm.endAt : "";
        }
      },

      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], //不需要设置值，直接写名字
              [{ header: 1 }, { header: 2 }], //需要设置值
              [{ script: "sub" }, { script: "super" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
              ["image"] //上传图片
            ]
          }
        }
      }
    };
  },
  methods: {
    submitForm (formName) {
      // var data = new FormData();
      // data.append("cotent", this.phoneEditor.txt.html());
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.thumbnailFile === null) {
            this.$message.warning("请上传网站版主题图！");
          } else if (this.thumbnailFileMo === null) {
            this.$message.warning("请上传手机版主题图！");
          } else {
            this.ruleForm.themePicture = this.thumbnailFile.themePicture;
            this.ruleForm.themePictureMobile = this.thumbnailFileMo.themePicture;
            this.ruleForm.fillList = this.ruleForm.fillListArray.join(",");
            this.ruleForm.content = this.phoneEditor.txt.html();

            let start = new Date(this.ruleForm.startAt)
            let end = new Date(this.ruleForm.endAt)

            this.ruleForm.startAt = start.getTime(start) / 1000
            this.ruleForm.endAt = end.getTime(end) / 1000

            if (this.isUpdata) {
              this.$emit("updataForm", this.ruleForm);
            } else {
              this.$emit("submitForm", this.ruleForm);
            }

          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    closeForm () {
      this.$emit("closeForm");
    },

    deleteThumbnailFile () {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除,
        customClass: 'messageBox-prompt-test'
      })
        .then(e => {
          this.thumbnailFile = null;
          this.$message.success("删除成功");
        })
        .catch(e => {
          // console.log("取消", i);
        });
    },
    deleteThumbnailFileMo () {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除,
        customClass: 'messageBox-prompt-test'
      })
        .then(e => {
          this.thumbnailFileMo = null;
          this.$message.success("删除成功");
        })
        .catch(e => {
          // console.log("取消", i);
        });
    },

    onChange (file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 20;

      const type = ["image/jpeg", "image/png", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
        return;
      }

      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg，gif和png！");
        return;
      }

      // console.log(file)
      this.isFile = true

      let bytesPerPiece;
      let totalPieces;
      let fileMD5;
      if (file.raw.size > 560000) {
        bytesPerPiece = 202020;
      } else {
        bytesPerPiece = 9888;
      }

      let fd = new FormData();
      fd.append("file", file.raw);
      getMD5(file.raw, md5 => {
        this.getFileInfoByHashAsync(
          md5,
          file.raw,
          bytesPerPiece,
          totalPieces,
          1
        );
      });
      // this.uploadPicAsync(fd, 1);
    },

    onChangeMo (file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 20;

      const type = ["image/jpeg", "image/png", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
        return;
      }

      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg，gif和png！");
        return;
      }

      // console.log(file)
      this.isFileMo = true

      let bytesPerPiece;
      let totalPieces;
      let fileMD5;
      if (file.raw.size > 560000) {
        bytesPerPiece = 202020;
      } else {
        bytesPerPiece = 9888;
      }

      let fd = new FormData();
      fd.append("file", file.raw);
      getMD5(file.raw, md5 => {
        this.getFileInfoByHashAsyncMo(
          md5,
          file.raw,
          bytesPerPiece,
          totalPieces,
          1
        );
      });
      // this.uploadPicAsync(fd, 1);
    },

    //分片上传
    fragmentationMo (val, blob, bytesPerPiece, totalPieces, insert) {
      var start = 0;
      var end;
      var index = 0;
      var filesize = blob.size;
      var filename = blob.name;

      totalPieces = Math.ceil(filesize / bytesPerPiece);

      while (start < filesize) {
        end = start + bytesPerPiece;
        if (end > filesize) {
          end = filesize;
        }

        var chunk = blob.slice(start, end); //切割文件
        var sliceIndex = blob.name + index;
        var formData = new FormData();
        formData.append("file", chunk);

        let params = {
          chunk: index,
          hash: val
        };

        if (index < totalPieces) {
          // console.log('分片次数',index)
          this.uploadPicChunkAsyncMo(params, formData, blob, insert);
        }
        if (index === totalPieces - 1) {
          // console.log('分片合并')
          params = {
            chunkCount: totalPieces,
            filename: blob.name,
            hash: val
          };
          this.uploadPicChunkMergeAsyncMo(params, blob, insert);
        }
        start = end;
        index++;
      }
    },
    //分片上传
    fragmentation (val, blob, bytesPerPiece, totalPieces, insert) {
      var start = 0;
      var end;
      var index = 0;
      var filesize = blob.size;
      var filename = blob.name;

      totalPieces = Math.ceil(filesize / bytesPerPiece);

      while (start < filesize) {
        end = start + bytesPerPiece;
        if (end > filesize) {
          end = filesize;
        }

        var chunk = blob.slice(start, end); //切割文件
        var sliceIndex = blob.name + index;
        var formData = new FormData();
        formData.append("file", chunk);

        let params = {
          chunk: index,
          hash: val
        };

        if (index < totalPieces) {
          // console.log('分片次数',index)
          this.uploadPicChunkAsync(params, formData, blob, insert);
        }
        if (index === totalPieces - 1) {
          // console.log('分片合并')
          params = {
            chunkCount: totalPieces,
            filename: blob.name,
            hash: val
          };
          this.uploadPicChunkMergeAsync(params, blob, insert);
        }
        start = end;
        index++;
      }
    },

    //常规文件上传
    async uploadPicAsyncMo (val, insert) {
      let { status, data, message } = await uploadPic(val);
      if (status) {
        if (insert === 1) {
          this.thumbnailFileMo = val;
          this.thumbnailFileMo.src = picPrefix + data.savepath;
          this.thumbnailFileMo.themePicture = data.savepath;
          this.isFileMo = false
        } else {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        }
      }
    },

    //分片上传接口第一步
    async uploadPicChunkAsyncMo (params, val, blob, insert) {
      let { status, data, message } = await uploadPicChunk(params, val);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsyncMo(fd, insert);
      } else {
        console.log("分片第一步");
      }
    },
    //分片上传接口第二步
    async uploadPicChunkMergeAsyncMo (params, blob, insert) {
      let { status, data, message } = await uploadPicChunkMerge(params);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsyncMo(fd, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
          // console.log(this.phoneEditor.txt.html().substring(this.phoneEditor.txt.html().indexOf('el-icon-loading') - 10,this.phoneEditor.txt.html().indexOf('el-icon-loading') + 21))
        } else {
          this.thumbnailFileMo = blob;
          this.thumbnailFileMo.src = picPrefix + data.savepath;
          this.thumbnailFileMo.themePicture = data.savepath;
          this.isFileMo = false
        }
      }
    },

    //常规文件上传
    async uploadPicAsync (val, insert) {
      let { status, data, message } = await uploadPic(val);
      if (status) {
        if (insert === 1) {
          this.thumbnailFile = val;
          this.thumbnailFile.src = picPrefix + data.savepath;
          this.thumbnailFile.themePicture = data.savepath;
          this.isFile = false
        } else {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        }
      }
    },

    //分片上传接口第一步
    async uploadPicChunkAsync (params, val, blob, insert) {
      let { status, data, message } = await uploadPicChunk(params, val);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsync(fd, insert);
      } else {
        console.log("分片第一步");
      }
    },
    //分片上传接口第二步
    async uploadPicChunkMergeAsync (params, blob, insert) {
      let { status, data, message } = await uploadPicChunkMerge(params);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsync(fd, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
          // console.log(this.phoneEditor.txt.html().substring(this.phoneEditor.txt.html().indexOf('el-icon-loading') - 10,this.phoneEditor.txt.html().indexOf('el-icon-loading') + 21))
        } else {
          this.thumbnailFile = blob;
          this.thumbnailFile.src = picPrefix + data.savepath;
          this.thumbnailFile.themePicture = data.savepath;
          this.isFile = false
        }
      }
    },
    //通过md5查询图片
    async getFileInfoByHashAsyncMo (val, blob, b, t, insert) {
      let { status, data, message } = await getFileInfoByHash(val);
      if (!status) {
        this.fragmentationMo(val, blob, b, t, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        } else {
          this.thumbnailFileMo = blob;
          this.thumbnailFileMo.src = picPrefix + data.savepath;
          this.thumbnailFileMo.themePicture = data.savepath;
          this.isFileMo = false
        }

      }
    },
    //通过md5查询图片
    async getFileInfoByHashAsync (val, blob, b, t, insert) {
      let { status, data, message } = await getFileInfoByHash(val);
      if (!status) {
        this.fragmentation(val, blob, b, t, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        } else {
          this.thumbnailFile = blob;
          this.thumbnailFile.src = picPrefix + data.savepath;
          this.thumbnailFile.themePicture = data.savepath;
          this.isFile = false
        }

      }
    },

    //查询活动模板列表
    async listAllowThemeAsync () {
      let { status, data, message, errors } = await listAllowTheme({ pageSize: 100 });
      if (status) {
        for (let i = 0; i < data.length; i++) {
          this.themeList.push({
            value: data[i].theme,
            title: data[i].title
          });
        }
        if (this.ruleForm.theme === '') {
          this.ruleForm.theme = this.themeList[0].value;
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    }

    // // 设置保存发送后台数据事件
    // submit() {
    //   var data = new FormData();
    //   data.append("cotent", this.phoneEditor.txt.html());
    //   this.$axios({
    //     methods: "post",
    //     url: "后台给的地址",
    //     data: data,
    //     headers: {
    //       token: window.localStorage["token"]
    //     }
    //   })
    //     .then(res => {
    //       if (res.status === 200) {
    //         console.log("success!");
    //       }
    //     })
    //     .catch(res => {
    //       console.log(res);
    //     });
    // }
  },
  created () {
    this.listAllowThemeAsync();
    // console.log(this.ruleForm.startAt)
    if (this.ruleForm.themePicture !== "") {
      this.thumbnailFile = {
        src: picPrefix + this.ruleForm.themePicture
      }
    }
    if (this.ruleForm.themePictureMobile !== "") {
      this.thumbnailFileMo = {
        src: picPrefix + this.ruleForm.themePictureMobile
      }
    }

    if (this.ruleForm.title) {
      this.isUpdata = true
    }


    // this.phoneEditor.txt.html(this.ruleForm.content)
    // console.log(this.ruleForm.startAt)
    this.ruleForm.startAt = formatConversion(this.ruleForm.startAt.toString(), 'havaTime')
    this.ruleForm.endAt = formatConversion(this.ruleForm.endAt.toString(), 'havaTime')
  },
  mounted () {
    var that = this;
    this.phoneEditor = new E("#websiteEditorElem");
    // 上传图片到服务器，base64形式
    // this.phoneEditor.customConfig.uploadImgShowBase64 = true;
    // 隐藏网络图片
    this.phoneEditor.customConfig.showLinkImg = false;

    // 配置服务器端地址
    // this.phoneEditor.customConfig.uploadImgServer = 'https://httpbin.org/post'

    // 自定义菜单配置
    this.phoneEditor.customConfig.menus = [
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      // 'link',  // 插入链接
      // 'list',  // 列表
      "justify", // 对齐方式
      "quote", // 引用
      "image", // 插入图片
      // 'table',  // 表格
      // 'video',  // 插入视频
      // 'code',  // 插入代码
      "undo", // 撤销
      "redo" // 重复
    ];

    // 将图片大小限制为 50M
    this.phoneEditor.customConfig.uploadImgMaxSize = 50 * 1024 * 1024;

    // 限制一次最多上传 10 张图片
    this.phoneEditor.customConfig.uploadImgMaxLength = 10;

    //上传图片事件
    this.phoneEditor.customConfig.customUploadImg = function (files, insert) {
      let bytesPerPiece;
      let totalPieces;
      let fileMD5;
      let icon = '<i style="font-size:24px" class="el-icon-loading"></i>'
      that.phoneEditor.txt.html(that.phoneEditor.txt.html() + icon)

      files.forEach(item => {
        // var reader = new FileReader();
        // reader.readAsDataURL(item);
        // reader.onload = function(e) {
        //   insert(this.result);
        // };

        if (item.size > 560000) {
          bytesPerPiece = 202020;
        } else {
          bytesPerPiece = 9888;
        }
        getMD5(item, md5 => {
          that.getFileInfoByHashAsync(
            md5,
            item,
            bytesPerPiece,
            totalPieces,
            insert
          );
        });

        // that.$nextTick(() => {
        //   that.phoneEditor.txt.html('')
        // });
      });

      // files.forEach(item => {
      //   that.$nextTick(()=>{
      //     let fd = new FormData();
      //     fd.append("file", item); // 上传的文件： 键名，键值
      //     axios.post("https://jsonplaceholder.typicode.com/posts/",{file:fd}
      //    )
      //     .then(res => {
      //       console.log(res)
      //     })
      //     .catch(res => {
      //       console.log(res);
      //     });
      //   })

      // 以下是上传图片的接口，视情况而更改就可以啦
      // 上传地址的接口名(fd).then(data => {
      //   // 上传代码返回结果之后，将图片插入到编辑器中
      //   insert(data.url);
      // });
      // });
    };

    // this.phoneEditor.customConfig.uploadImgHooks = {
    //   before: function (xhr, editor, files) {
    //       // 图片上传之前触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

    //       console.log(files)

    //       // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
    //       // return {
    //       //     prevent: true,
    //       //     msg: '放弃上传'
    //       // }
    //   },
    //   success: function (xhr, editor, result) {
    //       // 图片上传并返回结果，图片插入成功之后触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
    //   },
    //   fail: function (xhr, editor, result) {
    //       // 图片上传并返回结果，但图片插入错误时触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
    //   },
    //   error: function (xhr, editor) {
    //       // 图片上传出错时触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
    //   },
    //   timeout: function (xhr, editor) {
    //       // 图片上传超时时触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
    //   },

    //   // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
    //   // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
    //   customInsert: function (insertImg, result, editor) {
    //       // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
    //       // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

    //       // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
    //       var url = result.files['image.png']
    //       insertImg(url)

    //       // result 必须是一个 JSON 格式字符串！！！否则报错
    //   }
    // }

    // 创建一个富文本编辑器
    this.phoneEditor.create();
    // 富文本内容
    this.phoneEditor.txt.html(this.ruleForm.content);
  }
};
</script>

<style lang="scss" scoped>
.quill-editor /deep/ .ql-container {
  height: 240px !important;
}

#websiteEditorElem /deep/ .w-e-text-container {
  z-index: 3 !important;
}
#websiteEditorElem /deep/ .w-e-menu {
  z-index: 5 !important;
}
// #websiteEditorElem /deep/ .w-e-text-container,
// #websiteEditorElem /deep/ .w-e-toolbar
// {
//   z-index: 1999 !important;
// }

// .el-form /deep/ .el-input-number__decrease,
// .el-form /deep/ .el-input-number__increase{
//   z-index: 0.5 !important;
// }

.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 2px;
  // top: 0;
  z-index: 7;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn /deep/ .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
// .bottombtn /deep/ .el-button--primary {
//   background-color: #185ed3;
// }
/deep/ .el-form-item__label {
  font-weight: 600;
}
.imgbj {
  // &:hover .delete {
  //   opacity: 1;
  // }

  .imgs {
    width: 50px;
    height: 50px;
    position: absolute;
    top: -10px;
    left: 5px;
  }

  .delete {
    position: absolute;
    top: 15px;
    left: 60px;
    transform: 0.5s;
    opacity: 1;
    color: #185ed3;
    cursor: pointer;
  }
}

/deep/ .el-icon-circle-close {
  margin-top: 150px;
}
.msg {
  // position: absolute;
  // right: 0;
  // top: 0;
  font-size: 13px;
}

/deep/ .el-image-viewer__wrapper {
  z-index: 10003 !important;
}
.gjzw /deep/ .el-form-item__label {
  line-height: 45px;
  padding-right: 18px;
  // box-sizing: border-box;
}
// .tpbz /deep/ .el-form-item__label {
//   padding-right: 18px;
//   line-height: 45px;
// }
/deep/ .el-input-number--small {
  width: 105px;
}
</style>
